import React from 'react';
import PropTypes from 'prop-types';
import QualifiedPlayersListingContent from './QualifiedPlayersListingContent';
import Listing from '../../listing/js/Listing';
import { getDefaultFilters } from '../../listing/js/listing-helper';
import { getPredictiveSearchDefaultFilters } from './QualifiedPlayersPredictiveSearch';
import QualifiedPlayersListingLoadMore from './QualifiedPlayersListingLoadMore';
import QualifiedPlayersListingHeader from './QualifiedPlayersListingHeader';

export default class QualifiedPlayersListing extends React.PureComponent {
    constructor(props) {
        super(props);

        this.defaultFilters = {
            ...getPredictiveSearchDefaultFilters(),
            ...getDefaultFilters(props.options.filters)
        };
    }

    render() {
        return (
            <Listing options={this.props.options} defaultFilters={this.defaultFilters}
                render={({
                    isInitialRequestFulfilled,
                    onFiltersChange,
                    filters,
                    isFiltersApplied,
                    isFiltersDirty,
                    items,
                    pagination,
                    onLoadMore,
                    isLoadingMore
                }) => (
                    <div className="qualified-players-listing">
                        <QualifiedPlayersListingHeader
                            onFiltersChange={onFiltersChange}
                            filters={filters}
                            isFiltersApplied={isFiltersApplied}
                            isFiltersDirty={isFiltersDirty}
                            options={this.props.options}
                            itemsCount={items.length} />
                        <QualifiedPlayersListingContent isInitialRequestFulfilled={isInitialRequestFulfilled} items={items}/>
                        <QualifiedPlayersListingLoadMore
                            onLoadMore={onLoadMore}
                            pagination={pagination}
                            isLoadingMore={isLoadingMore}
                            loadMoreElement={this.props.loadMoreElement}/>
                    </div>
                )}/>
        );
    }
}

QualifiedPlayersListing.propTypes = {
    options: PropTypes.object.isRequired,
    loadMoreElement: PropTypes.instanceOf(Element).isRequired,
};
